import React, { ReactElement, useEffect, useRef, useState } from "react";
import useToggle from "_shared/hooks/useToggle";
import "./ContextMenu.scss";

const ContextMenuContext = React.createContext({
  left: 0,
  top: 0,
  showMenu: false,
  toggleMenu: () => {},
});

// wrapper for context menu trigger
const ContextMenu = ({ children }: { children: any }) => {
  const [left, setLeft] = useState(0);
  const [top, setTop] = useState(0);
  const [showMenu, toggleMenu] = useToggle();

  const ref = useRef<HTMLDivElement>(null);

  return (
    <ContextMenuContext.Provider value={{ left, top, showMenu, toggleMenu }}>
      <div
        ref={ref}
        onContextMenu={(e) => {
          e.preventDefault();
          const container = ref.current!.parentElement!;
          const rect = container.getBoundingClientRect();
          const newX = e.clientX - rect.left;
          const newY = e.clientY - rect.top;
          setLeft(newX);
          setTop(newY);
          if (!showMenu) toggleMenu();
        }}
      >
        {children}
      </div>
    </ContextMenuContext.Provider>
  );
};

interface MenuProps {
  children: ReactElement<typeof Item> | ReactElement<typeof Item>[];
}

const Menu = ({ children }: MenuProps) => {
  const { showMenu, toggleMenu, left, top } =
    React.useContext(ContextMenuContext);

  useEffect(() => {
    if (showMenu) {
      document.addEventListener("click", toggleMenu);
    }
    return () => {
      document.removeEventListener("click", toggleMenu);
    };
  }, [showMenu, toggleMenu]);

  if (!showMenu) return null;
  return (
    <ul
      className="context-menu"
      style={{
        position: "absolute",
        left,
        top,
      }}
    >
      {children}
    </ul>
  );
};

ContextMenu.Menu = Menu;

const Item = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick: () => void;
}) => {
  return (
    <li style={{ padding: "8px", fontSize: "13px" }} onClick={onClick}>
      {children}
    </li>
  );
};

ContextMenu.Item = Item;

export default ContextMenu;
